export const PNR_CHECK_CLICKED = 'rail_seo_trainlts_pnrcheck_clicked';
export const REFRESH_CLICKED = 'rail_seo_trainlts_refresh_clicked';
export const IN_BETWEEN_STATION_CLICKED = 'rail_seo_trainlts_inbetweenstation_clicked';
export const DATE_CLICKED = 'rail_seo_trainlts_date_clicked';

export const TRAIN_LTS_PAGENAME = 'seo:rails:trainlts:index';
export const LTS_ERROR_CODE = 'SEO_LTS_page_load_error';
